import { createContext, type ReactNode } from "react";
import type { AuthClient } from "../AuthClient";

/** @LearningJourney Authentication 8 - Provides AuthClient; use hooks like useGetToken instead of direct access */
export const authContext = createContext<
  { client: AuthClient; loginFallback: ReactNode } | undefined
>(undefined);
